// extracted by mini-css-extract-plugin
export default {"emptyFolder":"EmptyFolder__emptyFolder--2PeB0","emptyFolderTitle":"EmptyFolder__emptyFolderTitle--2y5db","emptyFolderSubtitle":"EmptyFolder__emptyFolderSubtitle--2ziID"};